module.exports = __webpack_public_path__ + "static/img/XB20.3d7c306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XB20.png
// module id = CYHi
// module chunks = 2